import React from 'react';

const Mississippi = () => {
  return (
    <div>
      
    </div>
  );
}

export default Mississippi;
